export const LIMIT_ITEM_PER_PAGE_PRODUCT_LIST = 20;

export const RECENTLY_VIEWED_PRODUCTS_KEY = 'viewed-products';

export const MOBILE_ITEM_PER_PAGE_IN_LISTING_PAGE = 10;

export const DESKTOP_ITEM_PER_PAGE_IN_LISTING_PAGE = 40;

export const SSR_DESKTOP_ITEM_PER_PAGE_IN_HOME_PAGE = 20;
